const size = {
  mobileS: 320 + 1,
  mobileM: 375 + 1,
  mobileL: 425 + 1,
  tablet: 768 + 1,
  laptop: 1024 + 1,
  laptopL: 1440 + 1,
  desktop: 2560 + 1,
};

export const device = {
  mobileS: `(max-width: ${size.mobileS}px)`, // 320px
  mobileM: `(max-width: ${size.mobileM}px)`, // 375px
  mobileL: `(max-width: ${size.mobileL}px)`, // 425px
  tablet: `(max-width: ${size.tablet}px)`, // 768px
  laptop: `(max-width: ${size.laptop}px)`, // 1024px
  laptopL: `(max-width: ${size.laptopL}px)`, // 1440px
  desktop: `(max-width: ${size.desktop}px)`, // 2560px
  // laptop: `(max-width: ${size.laptop - shopifyMenuWidth}px)`, // 784px
  // laptopL: `(max-width: ${size.laptopL - shopifyMenuWidth}px)`, // 1200px
  // desktop: `(max-width: ${size.desktop - shopifyMenuWidth}px)`, // 2320px
};
